<template>
  <path
    d="M13 1.07019V9.00019H20C20 4.92019 16.95 1.56019 13 1.07019ZM4 15.0002C4 19.4202 7.58 23.0002 12 23.0002C16.42 23.0002 20 19.4202 20 15.0002V11.0002H4V15.0002ZM11 1.07019C7.05 1.56019 4 4.92019 4 9.00019H11V1.07019Z"
  />
</template>
